import { render, staticRenderFns } from "./FrameAssemblyUpdateButton.vue?vue&type=template&id=0d9bac6e&scoped=true"
import script from "./FrameAssemblyUpdateButton.vue?vue&type=script&lang=ts"
export * from "./FrameAssemblyUpdateButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9bac6e",
  null
  
)

export default component.exports